import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import SearchField from 'src/shared/components/form/searchField';
import { StyledToggleButtonGroup } from 'src/shared/components/organisms/styledToggleButtonGroup';
import { EventParticipantStatusEnum } from 'src/shared/models/enums/eventParticipantStatus.enum';
import { Box, ToggleButton } from '@mui/material';
import { EventParticipant } from '../models/eventParticipant';

type EventParticipantFilterProps = {
  participants: EventParticipant[];
  selectedStatuses?: EventParticipantStatusEnum[];
  searchString?: string;
  onStatusChange: (val: EventParticipantStatusEnum[]) => void;
  onSearchStringChange: (val: string) => void;
};

export const EventParticipantFilter = (props: EventParticipantFilterProps) => {
  const { participants, selectedStatuses, searchString, onStatusChange, onSearchStringChange } = props;
  const { t } = useTranslation();

  const [eventParticipantStatuses, setEventParticipantStatuses] = useState<EventParticipantStatusEnum[]>();

  const handleKeys = (_event: React.MouseEvent<HTMLElement>, newKeys: EventParticipantStatusEnum[]) => {
    onStatusChange(newKeys);
  };

  useEffect(() => {
    if (participants) {
      const uniqueStatuses = participants.map((item) => item.status).filter((value, index, self) => self.indexOf(value) === index);
      setEventParticipantStatuses(uniqueStatuses);
    }
  }, [participants]);

  const getStatusLabel = (status: EventParticipantStatusEnum) => {
    if (status === EventParticipantStatusEnum.Attending) return t('event:participantStatuses.attending');
    if (status === EventParticipantStatusEnum.NotAttending) return t('event:participantStatuses.notAttending');
    if (status === EventParticipantStatusEnum.Cancelled) return t('event:participantStatuses.cancelled');
    return t('event:participantStatuses.unanswered');
  };

  return (
    <Box display='flex' alignItems='center' flexWrap='wrap' gap={2}>
      <Box>
        <SearchField initialValue={searchString || ''} onSearch={onSearchStringChange} />
      </Box>
      <FormFieldset legend={t('event:participantStatus')} noPadding displayInline>
        <StyledToggleButtonGroup value={selectedStatuses} onChange={handleKeys} color='primary' size='small'>
          {eventParticipantStatuses &&
            eventParticipantStatuses.map((x) => (
              <ToggleButton value={x} key={x}>
                {getStatusLabel(x)}
              </ToggleButton>
            ))}
        </StyledToggleButtonGroup>
      </FormFieldset>
    </Box>
  );
};
